<ng-container *ngIf="!isLoading; else loader">
  <ng-container *ngIf="!url; else logo">
    <div class="empty" (click)="onChoose.emit()">
      <div>{{placeHolder}}</div>
    </div>
  </ng-container>
  <ng-template #logo>
    <div class="not-empty" (click)="onChoose.emit()">
      <div>
        <img [src]="url" alt="logo">
      </div>
    </div>
  </ng-template>
</ng-container>
<ng-template #loader>
  <div class="not-empty">
    <ngx-inner-loading
      class="flex-center"
      [loading]="isLoading"
      [loadingDescription]="'Chargement...'"
    >
    </ngx-inner-loading>
  </div>
</ng-template>

